import { IPlayHubStore } from 'apps/BWW_PLAY_HUB/modules/utils/types';

export const getFilters = ( state: IPlayHubStore ) => state.filters;
